// extracted by mini-css-extract-plugin
module.exports = {"location":"locations-module--location--1QYjd"};